import styled from 'styled-components';
import { Button } from '@tryhackme/thm-ui-components';

import { StyledCertificationLogoProps } from './certification-banner.types';

export const StyledCertificationBanner = styled.div<{ $isTopBanner?: boolean }>`
  width: 100vw;
  height: 36.8rem;
  background-color: ${({ theme }) => theme.colors.secondary.main};
  background: linear-gradient(
    94.91deg,
    rgba(28, 37, 56, 1) 26.7%,
    rgba(31, 43, 67, 1) 52.53%,
    rgba(43, 59, 93, 1) 84.77%,
    rgba(31, 43, 67, 1) 104.21%,
    rgba(28, 37, 56, 1) 130.05%
  );

  margin-top: ${({ $isTopBanner }) => ($isTopBanner ? '0' : '4.8rem')};

  display: flex;
  justify-content: center;
  align-items: center;

  padding: ${({ $isTopBanner }) => ($isTopBanner ? '0' : '6.2rem 7.2rem')};
  overflow: hidden;
`;

export const StyledCertificationBannerContentWrapper = styled.div<{ $isTopBanner?: boolean }>`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  gap: ${({ $isTopBanner }) => ($isTopBanner ? 'unset' : '4.4rem')};
`;

export const StyledCertificationBannerTextWrapper = styled.div<{ $isTopBanner?: boolean }>`
  display: flex;
  flex-direction: column;
  margin-left: 0;
  max-width: 33.6rem;
  min-width: 30rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.sm}) {
    min-width: ${({ $isTopBanner }) => ($isTopBanner ? '79rem' : 'unset')};
    max-width: ${({ $isTopBanner }) => ($isTopBanner ? '77rem' : '100%')};
  }
`;

export const StyledCertificationLogo = styled.div<StyledCertificationLogoProps>`
  display: none;
  height: 36.8rem;
  width: auto;
  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    display: block;
  }

  svg {
    height: 100%;
    width: auto;
  }
`;

export const StyledH2CertificationBannerTitle = styled.h2`
  color: ${({ theme }) => theme.colors.grey[100]};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: 3.2rem;
  font-style: normal;
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  line-height: 2.7rem;
  margin: 1.6rem 0 1.6rem 0;
  position: relative;

  @media screen and (min-width: 1025px) {
    line-height: 3.677rem;
    font-size: ${({ theme }) => theme.fonts.sizes.subTitle};
  }
`;

export const StyledH2CertificationBannerTitleSpan = styled.span<{ $isTopBanner?: boolean }>`
  color: ${({ theme }) => theme.colors.primary.main};
  font-size: ${({ $isTopBanner }) => ($isTopBanner ? '1.6rem' : 'unset')};
`;

export const StyledPCertificationBannerDescription = styled.p`
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: 2rem;
  font-style: normal;
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: 2.3rem;
`;

export const StyledCertificationButton = styled(Button)`
  margin-top: 3.2rem;
  max-width: 12rem;

  &:hover:not(:disabled) {
    color: ${({ theme }) => theme.colors.grey[100]};
  }
`;

export const StyledCloseButton = styled.button`
  position: absolute;
  top: 2rem;
  right: 2rem;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.8rem;
  color: ${({ theme }) => theme.colors.grey[100]};
  transition: color 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.white};
  }

  svg {
    width: 2rem;
    height: 2rem;
  }
`;
